module.exports = __webpack_public_path__ + "media/images/icon_home-9fc3f99beb32eb3035c595760d403099.png";